export const fetchPlayerStats = async (marketId, statId, tokenQuery) => {
  const apiUrl = process.env.REACT_APP_API_URI.trim();

  try {
    const response = await fetch(
      `${apiUrl}/operator/fixture/market/players/stat/history/${marketId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + tokenQuery.data,
        },
        body: JSON.stringify({
          statId: statId,
        }),
      },
    );

    if (!response.ok) {
      throw new Error("Failed to fetch player statistics");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
